import * as React from "react";

export const Paint = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.375 4.5C12.375 4.99219 11.9648 5.375 11.5 5.375H1.875C1.38281 5.375 1 4.99219 1 4.5V1.875C1 1.41016 1.38281 1 1.875 1H11.5C11.9648 1 12.375 1.41016 12.375 1.875V4.5ZM13.25 2.75C14.207 2.75 15 3.54297 15 4.5V6.25C15 7.72656 13.8242 8.875 12.375 8.875H8V9.75C8.46484 9.75 8.875 10.1602 8.875 10.625V14.125C8.875 14.6172 8.46484 15 8 15H6.25C5.75781 15 5.375 14.6172 5.375 14.125V10.625C5.375 10.1602 5.75781 9.75 6.25 9.75V8.875C6.25 7.91797 7.01562 7.125 8 7.125H12.375C12.8398 7.125 13.25 6.74219 13.25 6.25V2.75Z"
    />
);
